import "./Analytics.css";
import Spinner from "../../Spin/Spinner";
import { getAvilableBalanceName } from "../../../config/LiveApi";
import { useState } from "react";

const AnalyticsTable = ({ tableData, setTableData, isLoading }) => {
  // console.log("Table data:", tableData);
 const [liveBalances, setLiveBalances] = useState({});
const [loadingBalanceId, setLoadingBalanceId] = useState(null);

  const minutesOfDayUTC = (iso) => {
  const d = new Date(iso);
  if (isNaN(d)) return null;
  return d.getUTCHours() * 60 + d.getUTCMinutes();
};

// Check if a time falls inside a modulo (wrap-around) range
const inRangeModulo = (t, start, end) => {
  if (start <= end) return t >= start && t < end;
  return t >= start || t < end; 
};  
const handleViewBalance = async (userId) => {
  try {
    setLoadingBalanceId(userId);

    const res = await getAvilableBalanceName(userId);
    setLiveBalances((prev) => ({
      ...prev,
      [userId]: res,
    }));

    setLoadingBalanceId(null);
  } catch (err) {
    console.error(err);
    setLiveBalances((prev) => ({
      ...prev,
      [userId]: "Error",
    }));
    setLoadingBalanceId(null);
  }
};



  return (
    <div className="analytics-table">
      <table className="table-analytics-management">
        <thead className="table-analytics-report">
          <tr>
            <td>
              <p className="analytics-table-head-report">Ledger Date</p>
            </td>
            <td>
              <p className="analytics-table-head-report">Payin Request Amount</p>
            </td>
            <td>
              <p className="analytics-table-head-report">
                Payin Comission
              </p>
            </td>
             <td>
              <p className="analytics-table-head-report">Rolling Reserve</p>
            </td>
            <td>
              <p className="analytics-table-head-report">Payout Request Amount</p>
            </td>
            <td>
              <p className="analytics-table-head-report">Payout Comission</p>
            </td>
            <td>
              <p className="analytics-table-head-report">Chargeback Amount</p>
            </td>
             <td>
              <p className="analytics-table-head-report">Chargeback Penality</p>
            </td>
             <td>
              <p className="analytics-table-head-report">Settlement Received(7PM-7AM)</p>
            </td>
             <td>
              <p className="analytics-table-head-report">Settlement Received(7AM-1PM)</p>
            </td>
             <td>
              <p className="analytics-table-head-report">Settlement Received(1PM-7PM)</p>
            </td>
              <td>
              <p className="analytics-table-head-report">Settlement Paid(7PM-7AM)</p>
            </td>
             <td>
              <p className="analytics-table-head-report">Settlement Paid(7AM-1PM)</p>
            </td>
             <td>
              <p className="analytics-table-head-report">Settlement Paid(1PM-7PM)</p>
            </td>
            <td>
              <p className="analytics-table-head-report">
                Rolling Reserve Unpaid
              </p>
            </td>
            <td>
              <p className="analytics-table-head-report">
                Rolling Reserve Paid
              </p>
            </td>
            <td>
              <p className="analytics-table-head-report">
               Wallet Amount
              </p>
            </td>
            <td>
              <p className="analytics-table-head-report">
             Avilable Balance
              </p>
            </td>
          </tr>
        </thead>

        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="100%">
                <div className="spinner-container">
                  <Spinner />
                </div>
              </td>
            </tr>
          ) : (
            tableData &&
            tableData.length > 0 &&
            tableData.map((item, index) => {
              // console.log("Item:", item);
              const [year, month, date] = item.end.split(" ")[0].split("-");

              const payinData = item.payinData;
              const payoutData = item.payoutData;
              const chargebackData = item.chargebackData;
              const walletdata = item.walletAmount;
              const userId= item.id;
// Prepare settlement buckets
let settlementReceived_7pm_7am = 0;
let settlementPaid_7pm_7am = 0;

let settlementReceived_7am_1pm = 0;
let settlementPaid_7am_1pm = 0;

let settlementReceived_1pm_7pm = 0;
let settlementPaid_1pm_7pm = 0;

let rollingReserveReceived = 0;
let rollingReservePaid = 0;


(item.settlementData || []).forEach((s) => {
    if (!s.settlementTimeRange && s.settlementAmount === 0) {
    if (s.rrAmount) rollingReserveReceived += s.rrAmount;
    if (s.paidAmount) rollingReservePaid += s.paidAmount;
    return; // Skip bucket logic entirely
  }
  if (!s.settledDate) return;

  const timeMinutes = minutesOfDayUTC(s.settledDate);

  // Time ranges in minutes
  const sevenPM = 19 * 60;  // 1140
  const sevenAM = 7 * 60;   // 420
  const onePM  = 13 * 60;   // 780

  // Night bucket (7PM → 7AM next day)
  if (inRangeModulo(timeMinutes, sevenPM, sevenAM)) {
    settlementReceived_7pm_7am += s.settlementAmount;
    settlementPaid_7pm_7am += s.paidAmount;
  }

  // Morning bucket (7AM → 1PM)
  if (timeMinutes >= sevenAM && timeMinutes < onePM) {
    settlementReceived_7am_1pm += s.settlementAmount;
    settlementPaid_7am_1pm += s.paidAmount;
  }

  // Afternoon bucket (1PM → 7PM)
  if (timeMinutes >= onePM && timeMinutes < sevenPM) {
    settlementReceived_1pm_7pm += s.settlementAmount;
    settlementPaid_1pm_7pm += s.paidAmount;
  }
});

              return (
                <tr key={index} className="analytics-table-head-report">
                  <td>
                    <p className="table-analytics-data-report order-break">
                      {`${date}-${month}-${year}`}
                    </p>
                  </td>
                  <td>
                    <p className="table-analytics-data-report order-break">
                      {payinData.requestAmountPayin
                        ? Number(payinData.requestAmountPayin).toFixed(2)
                        : "0.00"}
                    </p>
                  </td>
                  <td>
                    <p className="table-analytics-data-report order-break">
                      {payinData.totalComissionPayin
                        ? Number(payinData.totalComissionPayin).toFixed(2)
                        : "0.00"}
                    </p>
                  </td>
                   <td>
                    <p className="table-analytics-data-report order-break">
                      {payinData.rollingReserve
                        ? Number(payinData.rollingReserve).toFixed(2)
                        : "0.00"}
                    </p>
                  </td>
                  <td>
                    <p className="table-analytics-data-report order-break">
                      {payoutData.requestAmountPayout
                        ? Number(payoutData.requestAmountPayout).toFixed(2)
                        : "0.00"}
                    </p>
                  </td>
                  <td>
                    <p className="table-analytics-data-report">
                      {payoutData.totalComissionPayout
                        ? Number(payoutData.totalComissionPayout).toFixed(2)
                        : "0.00"}
                    </p>
                  </td>
                  <td>
                    <p className="table-analytics-data-report order-break">
                      {chargebackData.amount
                        ? Number(chargebackData.amount).toFixed(2)
                        : "0.00"}
                    </p>
                  </td>
                  <td>
                    <p className="table-analytics-data-report">
                     {chargebackData.penalty
                        ? Number(chargebackData.penalty).toFixed(2)
                        : "0.00"}
                    </p>
                  </td>
                  <td>
  <p className="table-analytics-data-report">
    {settlementReceived_7pm_7am.toFixed(2)}
  </p>
</td>
                  <td>
                    <p className="table-analytics-data-report">
                   {settlementReceived_7am_1pm.toFixed(2)}
                    </p>
                  </td>
                  <td>
                    <p className="table-analytics-data-report">
                   {settlementReceived_1pm_7pm.toFixed(2)}
                    </p>
                  </td>
                  <td>
                    <p className="table-analytics-data-report">
                    {settlementPaid_7pm_7am.toFixed(2)}
                    </p>
                  </td>
                  <td>
                    <p className="table-analytics-data-report">
                   {settlementPaid_7am_1pm.toFixed(2)}
                    </p>
                  </td>
                  <td>
                    <p className="table-analytics-data-report">
                   {settlementPaid_1pm_7pm.toFixed(2)}
                    </p>
                  </td>
                  <td>
                    <p className="table-analytics-data-report">
                    {rollingReserveReceived.toFixed(2)}
                    </p>
                  </td>
                  <td>
                    <p className="table-analytics-data-report">
                  {rollingReservePaid.toFixed(2)}
                    </p>
                  </td>
                  <td>
                    <p className="table-analytics-data-report">
                   {walletdata
                        ? Number(walletdata).toFixed(2)
                        : "0.00"}
                    </p>
                  </td>
                  <td>
  <p className="table-analytics-data-report">
    {liveBalances[userId] || liveBalances[userId] === 0 ? (
      <span>
        {parseFloat(liveBalances[userId]).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </span>
    ) : (
      <button
        onClick={() => handleViewBalance(userId)}
        disabled={loadingBalanceId === userId}
        style={{
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          padding: "4px 8px",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        {loadingBalanceId === userId ? "Loading..." : "View"}
      </button>
    )}
  </p>
</td>


                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AnalyticsTable;
